import { Component, OnInit } from '@angular/core';
import { FormsModule, FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';
import { FswService } from '@services/fsw.service';
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-new-product',
  templateUrl: './new-product.component.html',
  styleUrls: ['./new-product.component.scss']
})
export class NewProductComponent implements OnInit {

  addProductForm!: FormGroup;
  p: number = 1;
  itemsPerPage : number = 10;
  submitted = false;
  productList:any[]=[];
  productToSearch:any="";
  productListSearchFilter:any[]=[];
 
  constructor(private formBuilder: FormBuilder ,private fswService: FswService, private toastr: ToastrService  ,private spinnerService: NgxSpinnerService) { }

  ngOnInit(): void {
    this.addProductForm = this.formBuilder.group({
      product: ['', [Validators.required]],
    
    

    })
    this.getProducts();
  }
  getProducts()
  {
     this.fswService.getProducts().subscribe((resp)=>{

       this.productList=resp;
       this.productListSearchFilter=resp;


     } );
     console.log("hello");
  }
  deleteProduct(productId)
  {
    console.log(productId);
    var delBtn = confirm("Do you want to delete the product?");
    if(delBtn)
    {
      this.fswService.deleteProduct(productId).subscribe((resp)=>{

      this.getProducts();
 
 
      } );  
    }
  }
  saveProduct()
  {
     this.submitted = true;
    
     if (this.addProductForm.invalid) {
      return;
    }
    let  productName = this.addProductForm.get('product')?.value.replace(/ {2,}/g, ' ').trim();
    
   
    this.fswService.saveNewProduct( { "productName": productName}).subscribe((resp) => {  
      console.log(resp);
      this.submitted = false;
      if(resp.status==205)
      {
        this.toastr.error('Food Product Already Exists');
      }
      else
      {
        this.toastr.success('Food Product Added Successfully!');
      }
    })
  }
  
  searchProduct()
  {
    this.productListSearchFilter= this.productList.filter((proParam)=>
    {
       return (proParam.productName.toLowerCase().indexOf(this.productToSearch.toLowerCase())!=-1); 
    });
    console
  }
  resetParameter()
  {
    this. productToSearch="";
    this.productListSearchFilter= this.productList;
  }

}
